/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { OrderId } from "./OrderId";
import * as t from "io-ts";

/**
 * Data to perform a wallet verify with payment gateway
 */

/**
 * Redirection URL or iframe url according payment method type
 */

// required attributes
const WalletVerifyRequestsResponseDetailsR = t.interface({});

// optional attributes
const WalletVerifyRequestsResponseDetailsO = t.partial({});

export const WalletVerifyRequestsResponseDetails = t.intersection(
  [WalletVerifyRequestsResponseDetailsR, WalletVerifyRequestsResponseDetailsO],
  "WalletVerifyRequestsResponseDetails"
);

export type WalletVerifyRequestsResponseDetails = t.TypeOf<
  typeof WalletVerifyRequestsResponseDetails
>;

// required attributes
const WalletVerifyRequestsResponseR = t.interface({
  orderId: OrderId,

  details: WalletVerifyRequestsResponseDetails
});

// optional attributes
const WalletVerifyRequestsResponseO = t.partial({});

export const WalletVerifyRequestsResponse = t.intersection(
  [WalletVerifyRequestsResponseR, WalletVerifyRequestsResponseO],
  "WalletVerifyRequestsResponse"
);

export type WalletVerifyRequestsResponse = t.TypeOf<
  typeof WalletVerifyRequestsResponse
>;
